import(/* webpackMode: "eager" */ "/vercel/path0/app/(comLayout)/institucional/politicas-de-privacidade/page.tsx");
